import GamesScreenContent from "../../components/others/games/GamesScreenContent";
import GamesScreenLayout from "../../components/layouts/games/GamesScreenLayout";
import GamesScreenContentLayout from "../../components/layouts/games/GamesScreenContentLayout";
import SystemScreenTopBar from "../../components/bars/SystemScreenTopBar";
import {kHomeTexts} from "../../constants/texts";
import {useResizeListener} from "../../listeners/SystemResizeListener";
import {useState} from "react";
import SystemAppDrawer from "../../components/others/SystemAppDrawer";
import {Helmet} from "react-helmet";
import {buildHelmetTitle} from "../../helpers/SeoHelper";

export default function GamesScreen() {
    // Used in index.js to handle Games related content

    // PROPERTIES
    const [isDrawerOpen, setIsDrawerOpen] = useState(false)

    // HOOKS
    // ---- Set listener for potential open Modal during screen resize
    useResizeListener(() => setIsDrawerOpen(false))

    // BUILD
    return (
        <div className={"animate-appearSlow overflow-auto w-full h-[100svh] bg-backgroundLight3 flex flex-col justify-start items-center"}>
            {/** META */}
            <Helmet>
                <title>{buildHelmetTitle('Ummia - Jeux')}</title>
                <meta name="description"
                      content="Jeux pédagogiques mathématiques pour développer des réflexes quasi instinctifs." />
            </Helmet>
            {/** MODAL */}
            <SystemAppDrawer open={isDrawerOpen}
                             handleClose={() => setIsDrawerOpen(false)} />
            {/** CONTENT */}
            <SystemScreenTopBar currentTab={kHomeTexts.navGames}
                                openDrawer={openDrawer} />
            <GamesScreenLayout>
                <GamesScreenContentLayout>
                    <GamesScreenContent />
                </GamesScreenContentLayout>
            </GamesScreenLayout>
        </div>
    );

    // METHODS
    // ---- Open modal
    function openDrawer() {
        setIsDrawerOpen(true)
    }
}